import * as React from "react";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";

export function LinkFailed() {
    const currentLocation = window.location.href;

    return (
        <div>
            <h2>
                Whoops! The link to <strong>{currentLocation}</strong> didn't
                work!
            </h2>
            <p>
                <h1>
                    <Hyperlink whenClicked={() => {}} to="/">
                        <button style={{ color: "black", fontSize: `48px` }}>
                            Go back to the home page
                        </button>
                    </Hyperlink>
                </h1>
            </p>
        </div>
    );
}
